var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "order-btn" },
        [
          _c(
            "vxe-button",
            {
              on: {
                click: function ($event) {
                  return _vm.returnFun()
                },
              },
            },
            [_vm._v("返回")]
          ),
          _c(
            "vxe-button",
            {
              attrs: { status: "primary" },
              on: {
                click: function ($event) {
                  return _vm.saveMaterial()
                },
              },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
      _c("a-divider"),
      _c("div", { staticClass: "orderFormLine" }, [_vm._v("订单信息")]),
      _c(
        "div",
        { staticClass: "budgetBox" },
        [
          _c(
            "a-form",
            {
              ref: "orderForm",
              staticClass: "UniformCss",
              attrs: { inline: true, model: _vm.order, "label-width": "100px" },
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 3 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: { label: "订单编号", prop: "applyOrderCode" },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.applyOrderCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "applyOrderCode", $$v)
                              },
                              expression: "order.applyOrderCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 3 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "申领部门" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.order.orgName,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "orgName", $$v)
                              },
                              expression: "order.orgName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 3 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "申领人" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.order.applyMan,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "applyMan", $$v)
                              },
                              expression: "order.applyMan",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 3 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "收货人", prop: "receiverName" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.receiverName,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "receiverName", $$v)
                              },
                              expression: "order.receiverName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 3 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "收货人联系方式" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.order.receivePhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "receivePhone", $$v)
                              },
                              expression: "order.receivePhone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 9 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "收货地址" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.order.address,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "address", $$v)
                              },
                              expression: "order.address",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 3 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "审批总项数" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.order.orderMaterialCount,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "orderMaterialCount", $$v)
                              },
                              expression: "order.orderMaterialCount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 3 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "审批总数量" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.order.approveNums,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "approveNums", $$v)
                              },
                              expression: "order.approveNums",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 3 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "审批总金额" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.order.approveTotalSums,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "approveTotalSums", $$v)
                              },
                              expression: "order.approveTotalSums",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "orderFormLine" }, [_vm._v("物料信息")]),
          _c(
            "div",
            [
              !_vm.isdetail
                ? _c("div", { staticStyle: { padding: "10px 0px" } })
                : _vm._e(),
              _c(
                "vxe-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.materialList,
                    border: "",
                    "show-header-overflow": "",
                    "show-overflow": "",
                    "header-cell-style": { background: "#eef1f6" },
                  },
                },
                [
                  _c("vxe-table-column", {
                    attrs: {
                      field: "materialCode",
                      title: "物料号",
                      align: "center",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "materialName",
                      title: "物料名称",
                      align: "center",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "approveNums",
                      title: "审批数量",
                      align: "center",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "applyRemarks",
                      title: "申领备注",
                      width: "400",
                      align: "center",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "orderFormLine" }, [_vm._v("物流信息")]),
          _c(
            "div",
            {
              staticClass: "el-upload__tip",
              attrs: { slot: "tip" },
              slot: "tip",
            },
            [_vm._v("物流单号输入后需要点击“添加物流单号”按钮才可保存")]
          ),
          _c(
            "div",
            { staticStyle: { margin: "20px 0" } },
            [
              _vm._l(_vm.logisticsList, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticStyle: { "margin-bottom": "10px" } },
                  [
                    _c("a-input", {
                      staticStyle: { width: "300px", "margin-right": "10px" },
                      attrs: {
                        placeholder:
                          "物流单号输入后需要点击添加物流单号按钮才可保存",
                      },
                      model: {
                        value: _vm.logisticsList[index],
                        callback: function ($$v) {
                          _vm.$set(_vm.logisticsList, index, $$v)
                        },
                        expression: "logisticsList[index]",
                      },
                    }),
                    _vm.logisticsList.length > 1
                      ? _c(
                          "a-button",
                          {
                            attrs: { type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.removeLogistics(index)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _c("a-input", {
                staticStyle: { width: "300px", "margin-right": "10px" },
                attrs: { placeholder: "请输入物流单号" },
                model: {
                  value: _vm.newLogisticsNumber,
                  callback: function ($$v) {
                    _vm.newLogisticsNumber = $$v
                  },
                  expression: "newLogisticsNumber",
                },
              }),
              _c(
                "a-button",
                {
                  staticClass: "blue-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.addLogistics },
                },
                [_vm._v("添加物流单号")]
              ),
            ],
            2
          ),
          _c(
            "a-modal",
            {
              attrs: {
                title: "批量输入",
                visible: _vm.batchInputShow,
                width: "35%",
                closable: "",
                destroyOnClose: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.batchInputShow = $event
                },
                cancel: function () {
                  return (_vm.batchInputShow = false)
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "batchInputF",
                  staticClass: "UniformCss",
                  attrs: {
                    inline: true,
                    model: _vm.batchData,
                    "label-width": "90px",
                  },
                },
                [
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "物流单号:",
                                prop: "logisticsOrderCode",
                                rules: [
                                  {
                                    required: true,
                                    message: "物流单号不能为空!",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  oninput: "value=value.replace(/\\D/g, '')",
                                },
                                model: {
                                  value: _vm.batchData.logisticsOrderCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.batchData,
                                      "logisticsOrderCode",
                                      $$v
                                    )
                                  },
                                  expression: "batchData.logisticsOrderCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "vxe-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.batchInputShow = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      attrs: { status: "primary" },
                      on: { click: _vm.batchInputFun },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }